import React, { useContext } from 'react'
import Carousel from "./Carousel"
import { GlobalContext } from '../../reducer/context'

export const DashboardWrapper = ({ children }) => {
    const { utilityStates } = useContext(GlobalContext)
    const { hideDashboardBanner } = utilityStates

    return (
        <>
            <div className="osahan-home-page landing-page-mt">
                {!hideDashboardBanner &&
                    <section className='custom_home_slider'>
                        <Carousel id="mainSlider" bannerType="DashboardTop" />
                    </section>
                }
                {children}
                {/* <section className="categories-desktop">
                    <Carousel id="bottomSlider" bannerType="DashboardBottom" />
                </section> */}
            </div>
        </>
    )
}

export default DashboardWrapper;
